<div class="container-fluid">

	<div class="row row-header">
		<div class="col">

			<div class="breadcrumbs">
				@if (envName != 'production') {
				<span data-testid="SUBSYS1_REQUEST_SWVERSION_TXT" class="welcome-text">
					{{ buildVer }}
				</span>
				}
			</div>
			<div data-testid="SUBSYS1_REQUEST_LOGO_TXT" class="logo-full-text">
				{{ labels().APP_LOGO_TEXT }}
			</div>
			<h1 data-testid="SUBSYS1_REQUEST_TITLE_TXT">{{ labels().ACCOUNT_COMPONENT_HEADER }}</h1>

		</div>
	</div>

	<form [formGroup]="reqForm">
		<div class="row row-contents">

			<div class="col-8">
				<div data-testid="SUBSYS1_REQUEST_INFO_TXT" class="panel info">
					{{ labels().ACCOUNT_COMPONENT_INFO_TEXT }}
				</div>
			</div>

			<div class="col-4"></div>

			<div class="col-lg-3">
				<div class="form-group" id="email">
					<label data-testid="SUBSYS1_REQUEST_EMAIL_LBL" for="Email">
						{{ labels().ACCOUNT_COMPONENT_EMAIL }} *
					</label>
					<input data-testid="SUBSYS1_REQUEST_EMAIL_INPUT" type="email" class="form-control" id="Email"
						[placeholder]="labels().ACCOUNT_COMPONENT_EMAIL" formControlName="email"
						[class]="{'is-valid': reqForm.controls.email.valid && reqForm.controls.email.touched, 'is-invalid': reqForm.controls.email.invalid && reqForm.controls.email.touched}"
						[appFormValidationMsg]="usrErrorMsg.email">
				</div>
			</div>

			<div class="col-lg-3">
				<div class="form-group" id="confirm-email">
					<label data-testid="SUBSYS1_REQUEST_CONFEMAIL_LBL" for="ConfirmEmail">
						{{ labels().ACCOUNT_COMPONENT_CONFIRM_EMAIL }} *
					</label>
					<input data-testid="SUBSYS1_REQUEST_CONFEMAIL_INPUT" type="email" class="form-control" id="ConfirmEmail"
						[placeholder]="labels().ACCOUNT_COMPONENT_CONFIRM_EMAIL" formControlName="confirmEmail"
						[class]="{'is-valid': reqForm.controls.confirmEmail.valid && reqForm.controls.confirmEmail.touched, 'is-invalid': reqForm.controls.confirmEmail.invalid && reqForm.controls.confirmEmail.touched}"
						[appFormValidationMsg]="usrErrorMsg.confirmEmail">
				</div>
			</div>

			<div class="col-lg-6">
				<div class="form-group" id="role-type"
					[class]="{'is-valid': reqForm.controls.roleType.valid, 'is-invalid': reqForm.controls.roleType.invalid && reqForm.controls.roleType.touched}">
					<label data-testid="SUBSYS1_REQUEST_ROLETYPE_LBL" for="roleType">
						{{ labels().ACCOUNT_COMPONENT_ROLE_TYPE }} *
					</label>
					<div class="custom-control custom-radio custom-control-inline">
						<input data-testid="SUBSYS1_REQUEST_ROLETYPE_HCP_INPUT" type="radio" id="roleType-1" name="roleType"
							class="custom-control-input" [value]="HCP" formControlName="roleType" (ngModelChange)="updateRoleType()"
							[class]="{'is-valid': reqForm.controls.roleType.valid && reqForm.controls.roleType.touched, 'is-invalid': reqForm.controls.roleType.invalid && reqForm.controls.roleType.touched}">
						<label data-testid="SUBSYS1_REQUEST_ROLETYPE_HCP_LBL" class="custom-control-label" for="roleType-1">
							{{ labels().ACCOUNT_COMPONENT_HCP }}
						</label>
					</div>
					<div class="custom-control custom-radio custom-control-inline">
						<input data-testid="SUBSYS1_REQUEST_ROLETYPE_OTHERS_INPUT" type="radio" id="roleType-2" name="roleType"
							class="custom-control-input" [value]="OTHERS" formControlName="roleType"
							(ngModelChange)="updateRoleType()"
							[class]="{'is-valid': reqForm.controls.roleType.valid && reqForm.controls.roleType.touched, 'is-invalid': reqForm.controls.roleType.invalid && reqForm.controls.roleType.touched}">
						<label data-testid="SUBSYS1_REQUEST_ROLETYPE_OTHERS_LBL" class="custom-control-label" for="roleType-2">
							{{ labels().ACCOUNT_COMPONENT_OTHERS }}
						</label>
					</div>
				</div>
			</div>

			@if (isFormDetailsVisible()) {

			<div class="divider"></div>

			<div class="col-lg-3">
				<div class="form-group" id="first-name">
					<label data-testid="SUBSYS1_REQUEST_FIRSTNAME_LBL" for="firstName">
						{{ labels().ACCOUNT_COMPONENT_FIRST_NAME }} *
					</label>
					<input data-testid="SUBSYS1_REQUEST_FIRSTNAME_INPUT" type="text" autocomplete="off" class="form-control"
						id="firstName" [placeholder]="labels().ACCOUNT_COMPONENT_FIRST_NAME" formControlName="firstName"
						[class]="{'is-valid': reqForm.controls.firstName.valid && reqForm.controls.firstName.touched, 'is-invalid': reqForm.controls.firstName.invalid && reqForm.controls.firstName.touched}"
						[appFormValidationMsg]="usrErrorMsg.firstName">
				</div>
			</div>

			<div class="col-lg-3">
				<div class="form-group" id="last-name">
					<label data-testid="SUBSYS1_REQUEST_LASTNAME_LBL" for="lastName">{{ labels().ACCOUNT_COMPONENT_LAST_NAME }}
						*</label>
					<input data-testid="SUBSYS1_REQUEST_LASTNAME_INPUT" type="text" autocomplete="off" class="form-control"
						id="lastName" [placeholder]="labels().ACCOUNT_COMPONENT_LAST_NAME" formControlName="lastName"
						[class]="{'is-valid': reqForm.controls.lastName.valid && reqForm.controls.lastName.touched, 'is-invalid': reqForm.controls.lastName.invalid && reqForm.controls.lastName.touched}"
						[appFormValidationMsg]="usrErrorMsg.lastName">
				</div>
			</div>

			<div class="col-lg-3">
				<div class="form-group">
					<label data-testid="SUBSYS1_REQUEST_DATEBIRTH_LBL" for="dateOfBirth">
						{{ labels().ACCOUNT_COMPONENT_DATE_OF_BIRTH }} *
						<span data-testid="SUBSYS1_REQUEST_DATEFORMAT_TXT" class="date-format ms-3">{{ dateFormat }}</span>
					</label>
					<div class="input-group wrapper-calendar" #dateOfBirthTarget
						[class]="{'is-valid': reqForm.controls.dateOfBirth.valid && reqForm.controls.dateOfBirth.touched, 'is-invalid': reqForm.controls.dateOfBirth.invalid && reqForm.controls.dateOfBirth.touched }">
						<i data-testid="SUBSYS1_REQUEST_DATEBIRTH_TOGGLE_BTN"
							class="material-icons input-group-append icon-calendar" (click)="dateOfBirthPicker.toggle()"
							(keypress)="dateOfBirthPicker.toggle()">today</i>
						<input data-testid="SUBSYS1_REQUEST_DATEBIRTH_INPUT" type="text" autocomplete="off" class="form-control"
							id="dateOfBirth" [placeholder]="labels().ACCOUNT_COMPONENT_DATE_OF_BIRTH"
							formControlName="dateOfBirthFormat" (focus)="reqForm.controls.dateOfBirth.markAsTouched()"
							[class]="{'is-valid': reqForm.controls.dateOfBirth.valid && reqForm.controls.dateOfBirth.touched, 'is-invalid': reqForm.controls.dateOfBirth.invalid && reqForm.controls.dateOfBirth.touched }"
							readonly style="color: #fff" [appFormValidationMsg]="usrErrorMsg.dateOfBirth"
							[customControl]="reqForm.controls.dateOfBirth" [container]="dateOfBirthTarget" />
						<i data-testid="SUBSYS1_REQUEST_DATEBIRTH_CLEAR_BTN"
							class="material-icons input-group-append align-self-center md-18" (click)="clearDateOfBirth()"
							(keypress)="clearDateOfBirth()">clear</i>
					</div>
				</div>
				<datepicker data-testid="SUBSYS1_REQUEST_DATEBIRTH_DATEPICKER" #dateOfBirthPicker
					[value]="reqForm.value.dateOfBirth!" (dateChanged)="updateDateOfBirth($event)"
					[positionTarget]="dateOfBirthTarget" placement="bottom-right" [maxDate]="maxDateOfBirth" />
			</div>

			<div class="col-lg-3"></div>

			@if (isHospitalVisible()) {
			<div class="col-lg-3">
				<div class="form-group" id="hospital">
					<label data-testid="SUBSYS1_REQUEST_HOSPITAL_LBL" for="Hospital">
						{{ labels().ACCOUNT_COMPONENT_HOSPITAL }} *
					</label>
					<input data-testid="SUBSYS1_REQUEST_HOSPITAL_INPUT" type="text" autocomplete="off" class="form-control"
						id="Hospital" [placeholder]="labels().ACCOUNT_COMPONENT_HOSPITAL" formControlName="hospital"
						(ngModelChange)="updateHospital()" [ngbTypeahead]="mapsSrv.searchHospitals" [focusFirst]="false"
						[inputFormatter]="hospitalFormatter" [resultFormatter]="hospitalFormatter" (selectItem)="selectPOI($event)"
						[class]="{'is-valid': reqForm.controls.hospital.valid && reqForm.controls.hospital.touched, 'is-invalid': reqForm.controls.hospital.invalid && reqForm.controls.hospital.touched}"
						[appFormValidationMsg]="usrErrorMsg.hospital">
				</div>
			</div>
			}

			@if (isDistributorVisible()) {
			<div class="col-lg-3">
				<div class="form-group" id="distributor">
					<label data-testid="SUBSYS1_REQUEST_DISTRIBUTOR_LBL" for="Distributor">{{
						labels().ACCOUNT_COMPONENT_DISTRIBUTOR }} *</label>
					<input data-testid="SUBSYS1_REQUEST_DISTRIBUTOR_INPUT" type="text" autocomplete="off" class="form-control"
						id="Distributor" [placeholder]="labels().ACCOUNT_COMPONENT_DISTRIBUTOR" formControlName="distributor"
						[class]="{'is-valid': reqForm.controls.distributor.valid && reqForm.controls.distributor.touched, 'is-invalid': reqForm.controls.distributor.invalid && reqForm.controls.distributor.touched}"
						[appFormValidationMsg]="usrErrorMsg.distributor">
				</div>
			</div>
			}

			@if (isOtherRoleVisible()) {
			<div class="col-lg-3">
				<div class="form-group" id="other-role">
					<label data-testid="SUBSYS1_REQUEST_OTHERROLE_LBL" for="otherRole">
						{{ labels().ACCOUNT_COMPONENT_ROLE }} *
					</label>
					<select data-testid="SUBSYS1_REQUEST_OTHERROLE_SELECT" class="form-control custom-select" id="otherRole"
						autocomplete="off" formControlName="otherRole"
						[class]="{'is-valid': reqForm.controls.otherRole.valid && reqForm.controls.otherRole.touched, 'is-invalid': reqForm.controls.otherRole.invalid && reqForm.controls.otherRole.touched}"
						[appFormValidationMsg]="usrErrorMsg.otherRole">
						<option data-testid="SUBSYS1_REQUEST_OTHERROLE_OPTION_NULL" [ngValue]="null">
							{{ labels().ACCOUNT_COMPONENT_SELECT_ROLE }}
						</option>
						@for (role of allOtherRoles(); track $index) {
						<option [attr.data-testid]="'SUBSYS1_REQUEST_OTHERROLE_OPTION_' + ($index+1)" [ngValue]="role.value">
							{{ role.value }}
						</option>
						}
					</select>
				</div>
			</div>
			}

			@if (isCompanyVisible()) {
			<div class="col-lg-3">
				<div class="form-group" id="company">
					<label data-testid="SUBSYS1_REQUEST_COMPANY_LBL" for="Company">{{ labels().ACCOUNT_COMPONENT_COMPANY }}
						*</label>
					<input data-testid="SUBSYS1_REQUEST_COMPANY_INPUT" type="text" autocomplete="off" class="form-control"
						id="Company" [placeholder]="labels().ACCOUNT_COMPONENT_COMPANY" formControlName="company"
						(ngModelChange)="updateCompany()" [ngbTypeahead]="mapsSrv.searchCompanies"
						[inputFormatter]="companyFormatter" [resultFormatter]="companyFormatter" (selectItem)="selectPOI($event)"
						[class]="{'is-valid': reqForm.controls.company.valid && reqForm.controls.company.touched, 'is-invalid': reqForm.controls.company.invalid && reqForm.controls.company.touched}"
						[appFormValidationMsg]="usrErrorMsg.company">
				</div>
			</div>
			}

			<div class="divider"></div>

			<div class="col-lg-6">
				<div class="row">

					<div class="col-6">
						<div class="form-group" id="country">
							<label data-testid="SUBSYS1_REQUEST_COUNTRY_LBL" for="Country">{{ labels().ACCOUNT_COMPONENT_COUNTRY }}
								*</label>
							<select data-testid="SUBSYS1_REQUEST_COUNTRY_SELECT" class="form-control custom-select" id="Country"
								autocomplete="off" formControlName="country" [compareWith]="compareCountry"
								(ngModelChange)="updateCountry()"
								[class]="{'is-valid': reqForm.controls.country.valid && reqForm.controls.country.touched, 'is-invalid': reqForm.controls.country.invalid && reqForm.controls.country.touched}"
								[appFormValidationMsg]="usrErrorMsg.country">
								<option data-testid="SUBSYS1_REQUEST_COUNTRY_OPTION_NULL" [ngValue]="null">
									{{ labels().ACCOUNT_COMPONENT_SELECT_COUNTRY }}
								</option>
								@for (country of allCountries(); track $index) {
								<option [attr.data-testid]="'SUBSYS1_REQUEST_COUNTRY_OPTION_' + (country.code)" [ngValue]="country">
									{{ country.name }}
								</option>
								}
							</select>
						</div>
					</div>

					<div class="col-6">
						<div class="form-group" id="address">
							<label data-testid="SUBSYS1_REQUEST_ADDRESS_LBL" for="Address">
								{{ labels().ACCOUNT_COMPONENT_ADDRESS }} *
							</label>
							<input data-testid="SUBSYS1_REQUEST_ADDRESS_INPUT" type="text" autocomplete="off" class="form-control"
								id="Address" [placeholder]="labels().ACCOUNT_COMPONENT_ADDRESS" formControlName="address"
								[class]="{'is-valid': reqForm.controls.address.valid && reqForm.controls.address.touched, 'is-invalid': reqForm.controls.address.invalid && reqForm.controls.address.touched}"
								[appFormValidationMsg]="usrErrorMsg.address">
						</div>
					</div>

					<div class="col-6">
						@if (isUSStateVisible()) {
						<div class="form-group" id="state-province">
							<label data-testid="SUBSYS1_REQUEST_STATE_LBL" for="state-Province">
								{{ labels().ACCOUNT_COMPONENT_PROVINCE }} *
							</label>
							<select data-testid="SUBSYS1_REQUEST_STATE_SELECT" class="form-control custom-select" id="state-Province"
								autocomplete="off" formControlName="usStateProvince"
								[class]="{'is-valid': reqForm.controls.usStateProvince.valid && reqForm.controls.usStateProvince.touched, 'is-invalid': reqForm.controls.usStateProvince.invalid && reqForm.controls.usStateProvince.touched}"
								[appFormValidationMsg]="usrErrorMsg.usStateProvince">
								<option data-testid="SUBSYS1_REQUEST_STATE_OPTION_NULL" [ngValue]="null">
									{{ labels().ACCOUNT_COMPONENT_SELECT_STATE }}
								</option>
								@for (state of allUSStates(); track $index) {
								<option [attr.data-testid]="'SUBSYS1_REQUEST_STATE_OPTION_' + (state.code)" [ngValue]="state">
									{{ state.name }}
								</option>
								}
							</select>
						</div>
						} @else {
						<div class="form-group" id="stateProvince">
							<label data-testid="SUBSYS1_REQUEST_PROVINCE_LBL" for="StateProvince">
								{{ labels().ACCOUNT_COMPONENT_PROVINCE }} *
							</label>
							<input data-testid="SUBSYS1_REQUEST_PROVINCE_INPUT" type="text" autocomplete="off" class="form-control"
								id="StateProvince" [placeholder]="labels().ACCOUNT_COMPONENT_PROVINCE" formControlName="stateProvince"
								[class]="{'is-valid': reqForm.controls.stateProvince.valid && reqForm.controls.stateProvince.touched, 'is-invalid': reqForm.controls.stateProvince.invalid && reqForm.controls.stateProvince.touched}"
								[appFormValidationMsg]="usrErrorMsg.stateProvince">
						</div>
						}
					</div>

					<div class="col-6">
						<div class="form-group" id="city">
							<label data-testid="SUBSYS1_REQUEST_CITY_LBL" for="City">
								{{ labels().ACCOUNT_COMPONENT_CITY }} *
							</label>
							<input data-testid="SUBSYS1_REQUEST_CITY_INPUT" type="text" autocomplete="off" class="form-control"
								id="City" [placeholder]="labels().ACCOUNT_COMPONENT_CITY" formControlName="city"
								[class]="{'is-valid': reqForm.controls.city.valid && reqForm.controls.city.touched, 'is-invalid': reqForm.controls.city.invalid && reqForm.controls.city.touched}"
								[appFormValidationMsg]="usrErrorMsg.city">
						</div>
					</div>

					<div class="col-6">
						<div class="form-group" id="postal-code">
							<label data-testid="SUBSYS1_REQUEST_POSTALCODE_LBL" for="postalCode">
								{{ labels().ACCOUNT_COMPONENT_POSTAL_CODE }} *
							</label>
							<input data-testid="SUBSYS1_REQUEST_POSTALCODE_INPUT" type="text" autocomplete="off" class="form-control"
								id="postalCode" [placeholder]="labels().ACCOUNT_COMPONENT_POSTAL_CODE" formControlName="postalCode"
								[class]="{'is-valid': reqForm.controls.postalCode.valid && reqForm.controls.postalCode.touched, 'is-invalid': reqForm.controls.postalCode.invalid && reqForm.controls.postalCode.touched}"
								[appFormValidationMsg]="usrErrorMsg.postalCode">
						</div>
					</div>

					<div class="col-6">
						<div class="form-group" id="office-phone">
							<label data-testid="SUBSYS1_REQUEST_PHONE_LBL" for="officePhone">
								{{ labels().ACCOUNT_COMPONENT_PHONE }} *
							</label>
							<input data-testid="SUBSYS1_REQUEST_PHONE_INPUT" type="text" autocomplete="off" class="form-control"
								id="officePhone" [placeholder]="labels().ACCOUNT_COMPONENT_PHONE" formControlName="officePhone"
								[class]="{'is-valid': reqForm.controls.officePhone.valid && reqForm.controls.officePhone.touched, 'is-invalid': reqForm.controls.officePhone.invalid && reqForm.controls.officePhone.touched}"
								[appFormValidationMsg]="usrErrorMsg.officePhone">
						</div>
					</div>

					<div class="col-6">
						<div class="form-group" id="mobile-phone">
							<label data-testid="SUBSYS1_REQUEST_MOBILE_LBL" for="mobilePhone">
								{{ labels().ACCOUNT_COMPONENT_MOBILE }}
							</label>
							<input data-testid="SUBSYS1_REQUEST_MOBILE_INPUT" type="text" autocomplete="off" class="form-control"
								id="mobilePhone" [placeholder]="labels().ACCOUNT_COMPONENT_MOBILE" formControlName="mobilePhone"
								[class]="{'is-valid': reqForm.controls.mobilePhone.valid && reqForm.controls.mobilePhone.touched, 'is-invalid': reqForm.controls.mobilePhone.invalid && reqForm.controls.mobilePhone.touched}"
								[appFormValidationMsg]="usrErrorMsg.mobilePhone">
						</div>
					</div>

				</div>
			</div>

			<div class="col-lg-6">
				<div data-testid="SUBSYS1_REQUEST_MAP_BOX" id="map" class="user-request-map" [hidden]="!isMapVisible()">
					<app-map [position]="hospitalPosition()" />
				</div>
			</div>

			<div class="divider"></div>

			@if (isPracticeTypeVisible()) {
			<div class="col-lg-2">
				<div class="form-group" id="practice-type">
					<label data-testid="SUBSYS1_REQUEST_PRACTICETYPE_LBL" for="practiceType">
						{{ labels().ACCOUNT_COMPONENT_PRACTICE_TYPE }} *
					</label>
					<select data-testid="SUBSYS1_REQUEST_PRACTICETYPE_SELECT" class="form-control custom-select" id="practiceType"
						autocomplete="off" formControlName="practiceType" (ngModelChange)="updatePracticeType()"
						[class]="{'is-valid': reqForm.controls.practiceType.valid && reqForm.controls.practiceType.touched, 'is-invalid': reqForm.controls.practiceType.invalid && reqForm.controls.practiceType.touched}"
						[appFormValidationMsg]="usrErrorMsg.practiceType">
						<option data-testid="SUBSYS1_REQUEST_PRACTICETYPE_OPTION_NULL" [ngValue]="null">
							{{ labels().ACCOUNT_COMPONENT_SELECT_PRACTICE_TYPE }}
						</option>
						@for (type of allPracticeTypes(); track $index) {
						<option [attr.data-testid]="'SUBSYS1_REQUEST_PRACTICETYPE_OPTION_' + ($index+1)" [ngValue]="type.value">
							{{ type.value }}
						</option>
						}
					</select>
				</div>
			</div>
			}

			@if (isNpiVisible()) {
			<div class="col-lg-2">
				<div class="form-group" id="npi">
					<label data-testid="SUBSYS1_REQUEST_NPM_LBL" for="Npi">
						{{ labels().ACCOUNT_COMPONENT_NPI }} *
					</label>
					<input data-testid="SUBSYS1_REQUEST_NPM_INPUT" type="text" autocomplete="off" class="form-control" id="Npi"
						[placeholder]="labels().ACCOUNT_COMPONENT_NPI" formControlName="npi"
						[class]="{'is-valid': reqForm.controls.npi.valid && reqForm.controls.npi.touched, 'is-invalid': reqForm.controls.npi.invalid && reqForm.controls.npi.touched}"
						[appFormValidationMsg]="usrErrorMsg.npi">
				</div>
			</div>
			}

			@if (isStateLicense1Visible()) {
			<div class="col-lg-4" id="state-license-1">
				<label data-testid="SUBSYS1_REQUEST_LICENSE1_LBL" for="stateLicense1">
					{{ labels().ACCOUNT_COMPONENT_STATE_LICENSE_1 }} *
				</label>
				<div class="multirow-input">
					<div class="form-group">
						<select data-testid="SUBSYS1_REQUEST_LICENSE1_SELECT" class="form-control custom-select" id="stateLicense1"
							autocomplete="off" formControlName="stateCode1" (change)="updateStateCode(1)"
							[class]="{'is-valid': reqForm.controls.stateCode1.valid && reqForm.controls.stateCode1.touched, 'is-invalid': reqForm.controls.stateCode1.invalid && reqForm.controls.stateCode1.touched}"
							[appFormValidationMsg]="usrErrorMsg.stateCode1">
							<option data-testid="SUBSYS1_REQUEST_LICENSE1_OPTION_NULL" [ngValue]="null">-</option>
							@for (state of allUSStates(); track $index) {
							<option [attr.data-testid]="'SUBSYS1_REQUEST_LICENSE1_OPTION_' + (state.code)" [ngValue]="state.code">
								{{ state.code }}
							</option>
							}
						</select>
					</div>
					<div class="form-group">
						<input data-testid="SUBSYS1_REQUEST_LICENSE1_INPUT" type="text" autocomplete="off" class="form-control"
							id="licenseNumber1" [placeholder]="labels().ACCOUNT_COMPONENT_LICENSE_NUMBER"
							formControlName="licenseNumber1" (change)="updateLicenseNumber(1)"
							[class]="{'is-valid': reqForm.controls.licenseNumber1.valid && reqForm.controls.licenseNumber1.touched, 'is-invalid': reqForm.controls.licenseNumber1.invalid && reqForm.controls.licenseNumber1.touched}"
							[appFormValidationMsg]="usrErrorMsg.licenseNumber1">
					</div>
					<div class="form-group">
						@if (!isStateLicense2Visible()) {
						<div>
							<i data-testid="SUBSYS1_REQUEST_LICENSE1_ADD_BTN" class="material-icons"
								(click)="isStateLicense2Visible.set(true)" (keypress)="isStateLicense2Visible.set(true)">add</i>
						</div>
						}
					</div>
				</div>
			</div>
			}

			@if (isStateLicense2Visible()) {
			<div class="col-lg-4" id="state-license-2">
				<label data-testid="SUBSYS1_REQUEST_LICENSE2_LBL" for="stateLicense2">
					{{ labels().ACCOUNT_COMPONENT_STATE_LICENSE_2 }}
				</label>
				<div class="multirow-input">
					<div class="form-group">
						<select data-testid="SUBSYS1_REQUEST_LICENSE2_SELECT" class="form-control custom-select" id="stateLicense2"
							autocomplete="off" formControlName="stateCode2" (change)="updateStateCode(2)"
							[class]="{'is-valid': reqForm.controls.stateCode2.valid && reqForm.controls.stateCode2.touched, 'is-invalid': reqForm.controls.stateCode2.invalid && reqForm.controls.stateCode2.touched}"
							[appFormValidationMsg]="usrErrorMsg.stateCode2">
							<option data-testid="SUBSYS1_REQUEST_LICENSE2_OPTION_NULL" [ngValue]="null">-</option>
							@for (state of allUSStates(); track $index) {
							<option [attr.data-testid]="'SUBSYS1_REQUEST_LICENSE2_OPTION_' + (state.code)" [ngValue]="state.code">
								{{ state.code }}
							</option>
							}
						</select>
					</div>
					<div class="form-group">
						<input data-testid="SUBSYS1_REQUEST_LICENSE2_INPUT" type="text" autocomplete="off" class="form-control"
							id="licenseNumber2" [placeholder]="labels().ACCOUNT_COMPONENT_LICENSE_NUMBER"
							formControlName="licenseNumber2" (change)="updateLicenseNumber(2)"
							[class]="{'is-valid': reqForm.controls.licenseNumber2.valid && reqForm.controls.licenseNumber2.touched, 'is-invalid': reqForm.controls.licenseNumber2.invalid && reqForm.controls.licenseNumber2.touched}"
							[appFormValidationMsg]="usrErrorMsg.licenseNumber2">
					</div>
					<div class="form-group">
						@if (!isStateLicense3Visible()) {
						<div>
							<i data-testid="SUBSYS1_REQUEST_LICENSE2_REMOVE_BTN" class="material-icons"
								(click)="removeStateLicense(2)" (keypress)="removeStateLicense(2)">delete</i>
						</div>
						<div>
							<i data-testid="SUBSYS1_REQUEST_LICENSE2_ADD_BTN" class="material-icons"
								(click)="isStateLicense3Visible.set(true)" (keypress)="isStateLicense3Visible.set(true)">add</i>
						</div>
						}
					</div>
				</div>
			</div>
			}

			@if (isStateLicense3Visible()) {
			<div class="col-lg-4" id="state-license-3">
				<label data-testid="SUBSYS1_REQUEST_LICENSE3_LBL" for="stateLicense3">
					{{ labels().ACCOUNT_COMPONENT_STATE_LICENSE_3 }}
				</label>
				<div class="multirow-input">
					<div class="form-group">
						<select data-testid="SUBSYS1_REQUEST_LICENSE3_SELECT" class="form-control custom-select" id="stateLicense3"
							autocomplete="off" formControlName="stateCode3" (change)="updateStateCode(3)"
							[class]="{'is-valid': reqForm.controls.stateCode3.valid && reqForm.controls.stateCode3.touched, 'is-invalid': reqForm.controls.stateCode3.invalid && reqForm.controls.stateCode3.touched}"
							[appFormValidationMsg]="usrErrorMsg.stateCode3">
							<option data-testid="SUBSYS1_REQUEST_LICENSE3_OPTION_NULL" [ngValue]="null">-</option>
							@for (state of allUSStates(); track $index) {
							<option [attr.data-testid]="'SUBSYS1_REQUEST_LICENSE3_OPTION_' + (state.code)" [ngValue]="state.code">
								{{ state.code }}
							</option>
							}
						</select>
					</div>
					<div class="form-group">
						<input data-testid="SUBSYS1_REQUEST_LICENSE3_INPUT" type="text" autocomplete="off" class="form-control"
							id="licenseNumber3" [placeholder]="labels().ACCOUNT_COMPONENT_LICENSE_NUMBER"
							formControlName="licenseNumber3" (change)="updateLicenseNumber(3)"
							[class]="{'is-valid': reqForm.controls.licenseNumber3.valid && reqForm.controls.licenseNumber3.touched, 'is-invalid': reqForm.controls.licenseNumber3.invalid && reqForm.controls.licenseNumber3.touched}"
							[appFormValidationMsg]="usrErrorMsg.licenseNumber3">
					</div>
					<div class="form-group">
						@if (!isStateLicense4Visible()) {
						<div>
							<i data-testid="SUBSYS1_REQUEST_LICENSE3_REMOVE_BTN" class="material-icons"
								(click)="removeStateLicense(3)" (keypress)="removeStateLicense(3)">delete</i>
						</div>
						<div>
							<i data-testid="SUBSYS1_REQUEST_LICENSE3_ADD_BTN" class="material-icons"
								(click)="isStateLicense4Visible.set(true)" (keypress)="isStateLicense4Visible.set(true)">add</i>
						</div>
						}
					</div>
				</div>
			</div>
			}

			@if (isStateLicense4Visible()) {
			<div class="col-lg-4" id="state-license-4">
				<label data-testid="SUBSYS1_REQUEST_LICENSE4_LBL" for="stateLicense4">
					{{ labels().ACCOUNT_COMPONENT_STATE_LICENSE_4 }}
				</label>
				<div class="multirow-input">
					<div class="form-group">
						<select data-testid="SUBSYS1_REQUEST_LICENSE4_SELECT" class="form-control custom-select" id="stateLicense4"
							autocomplete="off" formControlName="stateCode4" (change)="updateStateCode(4)"
							[class]="{'is-valid': reqForm.controls.stateCode4.valid && reqForm.controls.stateCode4.touched, 'is-invalid': reqForm.controls.stateCode4.invalid && reqForm.controls.stateCode4.touched}"
							[appFormValidationMsg]="usrErrorMsg.stateCode4">
							<option data-testid="SUBSYS1_REQUEST_LICENSE4_OPTION_NULL" [ngValue]="null">-</option>
							@for (state of allUSStates(); track $index) {
							<option [attr.data-testid]="'SUBSYS1_REQUEST_LICENSE4_OPTION_' + (state.code)" [ngValue]="state.code">
								{{ state.code }}
							</option>
							}
						</select>
					</div>
					<div class="form-group">
						<input data-testid="SUBSYS1_REQUEST_LICENSE4_INPUT" type="text" autocomplete="off" class="form-control"
							id="licenseNumber4" [placeholder]="labels().ACCOUNT_COMPONENT_LICENSE_NUMBER"
							formControlName="licenseNumber4" (change)="updateLicenseNumber(4)"
							[class]="{'is-valid': reqForm.controls.licenseNumber4.valid && reqForm.controls.licenseNumber4.touched, 'is-invalid': reqForm.controls.licenseNumber4.invalid && reqForm.controls.licenseNumber4.touched}"
							[appFormValidationMsg]="usrErrorMsg.licenseNumber4">
					</div>
					<div class="form-group">
						@if (!isStateLicense5Visible()) {
						<div>
							<i data-testid="SUBSYS1_REQUEST_LICENSE4_REMOVE_BTN" class="material-icons"
								(click)="removeStateLicense(4)" (keypress)="removeStateLicense(4)">delete</i>
						</div>
						<div>
							<i data-testid="SUBSYS1_REQUEST_LICENSE4_ADD_BTN" class="material-icons"
								(click)="isStateLicense5Visible.set(true)" (keypress)="isStateLicense5Visible.set(true)">add</i>
						</div>
						}
					</div>
				</div>
			</div>
			}

			@if (isStateLicense5Visible()) {
			<div class="col-lg-4" id="state-license-5">
				<label data-testid="SUBSYS1_REQUEST_LICENSE5_LBL" for="stateLicense5">
					{{ labels().ACCOUNT_COMPONENT_STATE_LICENSE_5 }}
				</label>
				<div class="multirow-input">
					<div class="form-group">
						<select data-testid="SUBSYS1_REQUEST_LICENSE5_SELECT" class="form-control custom-select" id="stateLicense5"
							autocomplete="off" formControlName="stateCode5" (change)="updateStateCode(5)"
							[class]="{'is-valid': reqForm.controls.stateCode5.valid && reqForm.controls.stateCode5.touched, 'is-invalid': reqForm.controls.stateCode5.invalid && reqForm.controls.stateCode5.touched}"
							[appFormValidationMsg]="usrErrorMsg.stateCode5">
							<option data-testid="SUBSYS1_REQUEST_LICENSE5_OPTION_NULL" [ngValue]="null">-</option>
							@for (state of allUSStates(); track $index) {
							<option [attr.data-testid]="'SUBSYS1_REQUEST_LICENSE5_OPTION_' + (state.code)" [ngValue]="state.code">
								{{ state.code }}
							</option>
							}
						</select>
					</div>
					<div class="form-group">
						<input data-testid="SUBSYS1_REQUEST_LICENSE5_INPUT" type="text" autocomplete="off" class="form-control"
							id="licenseNumber5" [placeholder]="labels().ACCOUNT_COMPONENT_LICENSE_NUMBER"
							formControlName="licenseNumber5" (change)="updateLicenseNumber(5)"
							[class]="{'is-valid': reqForm.controls.licenseNumber5.valid && reqForm.controls.licenseNumber5.touched, 'is-invalid': reqForm.controls.licenseNumber5.invalid && reqForm.controls.licenseNumber5.touched}"
							[appFormValidationMsg]="usrErrorMsg.licenseNumber5">
					</div>
					<div class="form-group">
						<div>
							<i data-testid="SUBSYS1_REQUEST_LICENSE5_REMOVE_BTN" class="material-icons"
								(click)="removeStateLicense(5)" (keypress)="removeStateLicense(5)">delete</i>
						</div>
					</div>
				</div>
			</div>
			}

			}

			<div class="col-12">
				<div class="row">
					<div class="col-8">
						<p data-testid="SUBSYS1_REQUEST_LEGALSENTENCE_TXT">
							{{ labels().ACCOUNT_COMPONENT_LEGAL_SENTENCE }}
						</p>
						<button data-testid="SUBSYS1_REQUEST_SEND_BTN" type="button" class="btn btn-primary"
							[disabled]="!reqForm.valid" (click)="onSubmit()">
							{{ labels().ACCOUNT_COMPONENT_BUTTON_SEND }}
						</button>
					</div>
					<div class="col-4"></div>
				</div>
			</div>

		</div>
	</form>

</div>